var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.punto)?_c('levantamiento-de-datos',{attrs:{"is-new":true,"punto-iluminacion":_vm.punto,"is-read-only":false}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }